import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@sharedcommon/services/user.service';
import { environment } from '@sharedenvironment';

@Directive({
    selector: '[hasMenuRights]'
})
export class HasMenuRightsDirective {

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private userService: UserService) { }

    @Input() set hasMenuRights(rights: string[]) {
        const menuEntry = rights.shift();
        const allowedMenuEntries = environment.adminEntries;
        if (allowedMenuEntries.includes(menuEntry) && (this.userService.hasRights(rights) || rights.length === 0)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            // Else remove template from DOM
            this.viewContainer.clear();
        }
    }

}
